module.exports = __webpack_public_path__ + "static/media/start-screen-insurance.63f7b3d2.png";